import React from "react";

const Score = ({ data: { score, price, projected_fair_price } }) => {
  const isPositive = score >= 0;
  const color = isPositive ? "#21f698" : "#fc3841";

  // Cap the percentage at 100 for display purposes
  const cappedPercentage = Math.min(Math.abs(score), 100);

  // SVG circle calculations
  const size = 100;
  const strokeWidth = 8;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - cappedPercentage / 100);

  return (
    <div className="flex w-fit h-1/2 mx-auto min-w-[280px]">
      <div className="flex relative scale-1 w-full h-full justify-center items-center">
        <svg
          className="flex w-64 h-64 sm:w-72 sm:h-72 md:w-96 md:h-96"
          viewBox={`0 0 ${size} ${size}`}
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background circle (remaining portion) */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            opacity={0.6}
          />
          {/* Foreground circle (filled portion) */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        </svg>
        <div className="flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex-col h-64 w-64 sm:h-72 sm:w-72 md:w-96 md:h-96 items-center justify-center">
          <div className="text-[0.8em] text-gray-300 mb-6">fomo score</div>
          <div className={`text-5xl sm:text-6xl md:text-7xl ${isPositive ? "positive" : "negative"}`}>
            {score}%
          </div>
          <div className="text-sm text-gray-300 mt-8">
            Current Price: ${price.toFixed(2)}
          </div>
          <div className="text-sm text-gray-300">
            Fair Value: ${projected_fair_price.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Score;
